import m from "../../geodata/es2015/sloveniaRegionsLow";
window.am4geodata_sloveniaRegionsLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/sloveniaRegionsLow.js
// module id = null
// module chunks = 